export default {
    heading: "Family",
    home: {
        error: {
            noEmail: "To activate the Family function, your account must be linked to the login email address. Click <a href='{link}'>here</a> to update your Profile.",
            functionalAccount: "The Family function is limited to Student Members and Public Members only. Please switch to an eligible account type and attempt again",
            studentAccount: "The Family function is limited to Student Members and Public Members. Please click <a href='{link}'>here</a> to upgrade your membership.",
            cannotCreateOrJoin: "Something went wrong.",
            full: "The family reaches its full capacity.",
            expired: "The family verification code has expired. Please reach out to your family administrator to regenerate a new verification code.",
        },
    },
    index: {
        heading: "Create a New Family",
        text: {
            info: "Welcome to use Family Group Service.",
            info2: "Once joining a Family Group, other family members will be able to view your account information.",
            studentInfo: "Welcome to use Family Group Service.",
            hint: "* You can only join one Family Group at a time",
            or: "Or",
            formInfo: "Please enter the family information below.",
            recaptcha: "reCAPTCHA temporarily disabled",
            createInfo: "Create a family and invite your family members",
            shareMessage: "You can invite your family members to create a family either by email or through WhatsApp.",
        },
        label: {
            familyName: "Family Name",
            nickname: "Your Nickname in the family",
            role: "Your Role in the family",
            submit: "Finish",
            back: "Back",
            receiverEmail: "Receiver's Email Address",
            invite: 'Invite to Create a New Family',
        },
        placeholder: {
            nickname: "Maximum 100 characters",
        },
        validation: {
            familyNameIsEmpty: "Please enter the name of the family.",
            nicknameIsEmpty: "Please enter your nickname.",
            roleIsEmpty: "Please select a family role.",
            roleIsInvalid: "Incorrect family role. Please make a new selection.",
            familyNameBadword: "Family name cannot include indecent language. Please use another name.",
            familyNameExceedMax: "The maximum number of characters allowed is 100.",
            nicknameBadword: "Your nickname cannot include indecent language. Please use a different name.",
            nicknameExceedMax: "The maximum number of characters allowed is 100.",
            receiverEmailIsEmpty: "Please enter the receiver email address.",
            receiverEmailFormatWrong: "Invalid email address format. Please try again.",
        },
        button: {
            create: "Create <br/> a New Family",
            join: "Join an <br/> Existing Family",
            faq: "FAQ",
            video: "Video Guide",
            invite: 'Invite to <br /> create a Family',
            email: "Email",
            send: "Send",
            cancel: "Cancel",
        },
        confirmCreate: {
            message: "Please confirm to create a new family",
            confirm: "Create"
        }
    },
    join: {
        heading: "Join an Existing Family",
        text: {
            info: "Please enter the family information below.",
            expired: "Join Hyperlink is expired",
            incorrect: "The invite link is invalid",
            recaptcha: "reCAPTCHA temporarily disabled",
        },
        label: {
            adminEmail: "Admin Email Address",
            code: "Family Vertificaiton Code",
            nickname: "Your Nickname in the family",
            role: "Your Role in the family",
            familyRef: "Family Reference Number",
        },
        button: {
            submit: "Finish",
            back: "Back",
        },
        placeholder: {
            nickname: "Maximum 100 characters",
        },
        validation: {
            adminEmailIsEmpty: "Please enter the family admin email address.",
            codeIsInvalid: "The family verification code format is invalid. Please double check and try again.",
            codeIsEmpty: "Please enter the family verification code.",
            nicknameIsEmpty: "Please enter your nickname.",
            roleIsEmpty: "Please select a family role.",
            roleIsInvalid: "Incorrect family role. Please make a new selection.",
            adminEmailFormatWrong: "Invalid email address format. Please try again.",
            adminEmailNotFound: "The family admin email address was not found.",
            codeNotMatch: "The family verification code is not match with the family admin's family verification code.",
            groupNotFound: "Cannot find the family.",
            nicknameBadword: "Your nickname cannot include indecent language. Please use a different name.",
            nicknameExceedMax: "The maximum number of characters allowed is 100.",
            familyRefIsEmpty: "Please enter the family reference number.",
            familyRefExceedMax: "The maximum number of characters allowed is 10.",
        }
    },
    hold: {
        info: "You have made more than 5 incorrect requests within the past 24 hours. Please try again after {displayDatetime}. ",
    },
    request: {
        text: {
            info: "You can withdraw requests that are pending or denied by the Family Admin",
            wait: "The request has been sent to the family administrator and is awaiting approval.",
            decline: "The administrator has declined the request.",
            kick: "You have been removed from the family by the administrator.",
            dismiss: "The administrator has dismissed the family.",
            group: "Family Information",
        },
        button: {
            cancel: "Cancel Request",
            acknowledged: "Yes, I understand.",
            refresh: "Refresh",
        },
        confirmWidthdraw: {
            message: "Withdraw this family join request?",
        },
    },
    details: {
        text: {
            dismissed: "This family has been dismissed, please click the Leave family button.",
            editDialogTitle: "Edit Information",
            copied: "Join link has been copied.",
            updated: "Information has been updated successfully.",
            expired: "The family verification code has expired. Please regenerate a new code before copying it.",
            regened: "A new family verification code has been generated.",
            left: "You have left the family.",
            notMember: "You have left the family successfully.",
            beKicked: "You have been removed from the family",
            dismiss: "This family has already been dismissed.",
            memberUpdated: "Your member information has been modified.",
            accepted: "The join request has been accepted.",
            declined: "The family request is declined",
            kicked: "This family member has been removed successfully.",
            kickout: "This member has already left the family.",
            withdrawn: "The join request has been withdrawn.",
            processed: "The request is already handled",
            handled: "Unable to withdraw a join request that has already been processed.",
            upgraded: "This member has been set as a family admin successfully.",
            downgraded: "This member’s admin role has been revoked successfully. ",
            acceptedAndUpgraded: "The join request has been accepted, and the member has been set as a family admin.",
            notAdmin: "You have been removed from the admin role.",
            singleAdmin: "This operation cannot be performed as every family must have at least one family admin.",
            multipleAdmin: "This operation cannot be performed as there are multiple family admins.",
            notUpgrade: "This member is already a family admin.",
            notDowngrade: "This member is no longer a family admin.",
            shareInfo: "Add your family members by sharing an invite link or providing them with the family reference number and verification code.",
            expiredEmail: "The family verification code has expired. Please regenerate a new code before sending any invitation email.",
            expiredWhatsapp: "The family verification code has expired. Please regenerate a new code before sending any WhatsApp invitation.",
            member: "Family Member {nickname}",
            cannotDismiss: "This function is unavailable as there are multiple administrators for this family.",
            cannotLeave: "This function is unavailable as there is only one family administrator for this family.",
            error: "Something went wrong.",
            requestNotFound: "Cannot find the request.",
            memberNotFound: "Cannot find the member.",
        },
        label: {
            familyName: "Family Name",
            createDate: "Family Verification Code Generation Date",
            expiryDate: "Family Verification Code Expiry Date",
            request: "Request",
            member: "Member",
            role: "Family Role",
            status: "Status",
            actions: "Actions",
            expired: "Expired",
            you: "You",
            dismissed: "Dismissed",
            admin: "Admin",
            person: "person",
            memberList: "Member List",
            requestList: "Request List",
            receiverEmail: "Receiver's Email Address",
            familyRef: "Family Reference Number",
            nickname: "Your Nickname in the family",
            editRole: "Your Role in the family",
            code: "Family Verification Code",
        },
        placeholder: {
            nickname: "Max length is 100",
        },
        validation: {
            familyNameIsEmpty: "Please enter the name of the family.",
            familyNameBadword: "Your family name cannot include indecent languages. Please use a different name.",
            familyNameExceedMax: "The maximum number of characters allowed is 100.",
            roleIsEmpty: "Please select a family role.",
            roleIsInvalid: "Incorrect family role. Please make a new selection.",
            nicknameIsEmpty: "Please enter your nickname.",
            nicknameBadword: "Your nickname cannot include indecent language. Please use a different name.",
            nicknameExceedMax: "The maximum number of characters allowed is 100.",
            receiverEmailIsEmpty: "Please enter the receiver email address.",
            receiverEmailFormatWrong: "Invalid email address format. Please try again.",
        },
        button: {
            update: "Update Family Name",
            regenerate: "REGENERATE",
            dismiss: "Dismiss the Family",
            leave: "Leave the Family",
            edit: "Edit",
            cancel: "Cancel",
            previous: "Previous Page",
            next: "next Page",
            share: "Copy Join Hyperlink",
            familyInfo: "Invite Family Member(s)",
            refresh: "Refresh",
            confirm: "Confirm",
            acceptMember: "Accept Request",
            declineMember: "Decline Request",
            kick: "Remove this Member",
            upgrade: "Upgrade Family Admin",
            downgrade: "Remove Admin Role",
            acceptAndUpgrade: "Accept member & Upgrade Family Admin",
            send: "Send",
            invite: "Share",
            email: "Email",
            execute: "Edit",
            copy: "Copy Link",
            yes: "Yes",
            no: "No",
            decline: "Decline",
        },
        confirmRegenerate: {
            message: "Are you sure you want to regenerate the family verification code?"
        },
        confirmAccept: {
            message: "Accept {nickname} to join your family?"
        },
        confirmDecline: {
            message: "Decline {nickname} to join your family?"
        },
        confirmKick: {
            message: "Are you sure you want to remove {nickname} from this family?",
        },
        confirmDismiss: {
            message: "Are you sure you want to dismiss this family?",
        },
        confirmLeave: {
            message: "Are you sure you want to leave this family?",
        },
        confirmUpgrade: {
            message: "Are you sure you want to set {nickname} as the family admin?",
        },
        confirmDowngrade: {
            message: "Are you sure you want to remove {nickname}'s admin role and privileges? ",
        },
        confirmAcceptAndUpgrade: {
            message: "Accept this member to join Family and upgrade this member as a Family Admin?",
        },
        share: {
            title: "I would like to invite you to Join a Family in Edcity",
            content: "I would like to invite you to join a family in Hong Kong Education City (EdCity)",
            email: {
                subject: "{fullname} invites you to Join a Family in Edcity",
                content: "Hello! \n \n In order to enhance parent-child learning communication, I would like to invite you to join a family in Hong Kong Education City (EdCity). To learn more about EdCity, please click the link below: \n https://www.edcity.hk/hq/en/content/aboutus \n If you do not have an account with EdCity, please click the link below to create one:\n https://www.edcity.hk/hq/en/content/membership/public \n If you already have an account in EdCity, please click the link below to log in and join a family:\n {familyLink} \n \n Your family member \n {fullname}",
            },
        },
    },
    share: {
        title: "I would like to invite you to Create New Family in Edcity",
        content: "I would like to invite you to set up a family in Hong Kong Education City (EdCity). ",
        email: {
            subject: "{fullname} invites you to Create New Family in Edcity",
            content: "Hello! \n \n To enhance parent-child learning communication, I would like to invite you to set up a family in Hong Kong Education City (EdCity). To learn more about EdCity, please click the link below: \n https://www.edcity.hk/hq/en/content/aboutus \n If you do not have an EdCity account, please click the link below to create one: \n https://www.edcity.hk/hq/en/content/membership/public \n If you already have an EdCity account, please click the link below to log in and create a family:  \n {familyLink} \n \n Your family member \n {fullname}",
        },
    },
};
